import React from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FitnessFamily() {
  return <section className="py-24 bg-off-white" data-id="element-1407">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1408">
        <div className="grid lg:grid-cols-2 gap-16 items-center flex-col-reverse lg:flex-row" data-id="element-1409">
          <div className="order-2 lg:order-1" data-id="element-1410">
            <img src={SITE_IMAGES.familyClasses} alt="Family martial arts fitness" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1411" />
          </div>
          <div className="order-1 lg:order-2" data-id="element-1412">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1413">
              <Users className="w-4 h-4" data-id="element-1414" />
              Family Programs
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1415">
              Train and Grow Together
            </h2>
            <p className="text-lg text-gray-warm mb-6" data-id="element-1416">
              Finding time for personal fitness while managing family activities
              is tough. Storm's Family Classes solve this by letting parents and
              children train together on the same mat.
            </p>
            <p className="text-lg text-gray-warm mb-8" data-id="element-1417">
              Share the journey of earning belts, support each other through
              challenging workouts, and build a foundation of health and fitness
              as a family unit.
            </p>
            <Link to="/FamilyKarateClasses.html" className="btn-primary" data-id="element-1418">
              Explore Family Classes
            </Link>
          </div>
        </div>
      </div>
    </section>;
}